/**
 * ============================================================================
 * VINPOP SHIPPING RATES CONFIGURATION
 * ============================================================================
 * 
 * Ce fichier contient tous les tarifs de livraison par zone et par quantité.
 * 
 * COMMENT MODIFIER LES TARIFS:
 * 1. Trouvez la zone concernée (NETHERLANDS ou FRANCE_SPAIN)
 * 2. Modifiez le prix dans la propriété "price"
 * 3. Pour modifier les seuils de bouteilles, changez "minBottles" et "maxBottles"
 * 4. Sauvegardez et déployez
 * 
 * ============================================================================
 */

window.VinpopShippingConfig = {
  
  // =========================================================================
  // ZONES DE LIVRAISON
  // =========================================================================
  
  zones: {
    
    // -----------------------------------------------------------------------
    // HOLLANDE (Pays-Bas)
    // -----------------------------------------------------------------------
    NETHERLANDS: {
      name: "Netherlands",
      flag: "🇳🇱",
      displayName: {
        en: "Netherlands",
        nl: "Nederland",
        fr: "Pays-Bas",
        de: "Niederlande",
        es: "Países Bajos"
      },
      countries: ["NL", "Netherlands", "Pays-Bas", "Nederland", "BE", "Belgium", "België", "Belgique"],
      
      // 2026-09-28 : copie EXACTE des tarifs Shopify (Settings > Shipping and delivery, zone
      // « Europe » Netherlands + Belgium), qui sont ceux factures au paiement. La grille
      // 9,90 / 6,90 / 3,90 du 2026-09-19 n'a jamais ete appliquee dans Shopify : le site affichait
      // une livraison moins chere que celle facturee. Toute modification des tarifs Shopify doit
      // etre recopiee ici.
      rates: [
        {
          minBottles: 1,
          maxBottles: 3,
          price: 14.40,
          description: "1-3 bouteilles"
        },
        {
          minBottles: 4,
          maxBottles: 5,
          price: 11.90,
          description: "4-5 bouteilles"
        },
        {
          minBottles: 6,
          maxBottles: 7,
          price: 8.90,
          description: "6-7 bouteilles"
        },
        {
          minBottles: 8,
          maxBottles: 9,
          price: 5.90,
          description: "8-9 bouteilles"
        },
        {
          minBottles: 10,
          maxBottles: 11,
          price: 2.90,
          description: "10-11 bouteilles"
        },
        {
          minBottles: 12,
          maxBottles: Infinity,
          price: 0,           // GRATUIT
          description: "12+ bouteilles"
        }
      ]
    },
    
    // -----------------------------------------------------------------------
    // FRANCE & ESPAGNE
    // -----------------------------------------------------------------------
    FRANCE_SPAIN: {
      name: "France & Spain",
      // Les drapeaux sont déterminés dynamiquement selon le pays exact
      countries: ["FR", "France", "ES", "Spain", "Espagne", "España"],
      countryFlags: {
        "FR": "🇫🇷",
        "France": "🇫🇷",
        "ES": "🇪🇸",
        "Spain": "🇪🇸",
        "Espagne": "🇪🇸",
        "España": "🇪🇸"
      },
      countryNames: {
        "FR": { en: "France", nl: "Frankrijk", fr: "France", de: "Frankreich", es: "Francia" },
        "France": { en: "France", nl: "Frankrijk", fr: "France", de: "Frankreich", es: "Francia" },
        "ES": { en: "Spain", nl: "Spanje", fr: "Espagne", de: "Spanien", es: "España" },
        "Spain": { en: "Spain", nl: "Spanje", fr: "Espagne", de: "Spanien", es: "España" },
        "Espagne": { en: "Spain", nl: "Spanje", fr: "Espagne", de: "Spanien", es: "España" },
        "España": { en: "Spain", nl: "Spanje", fr: "Espagne", de: "Spanien", es: "España" }
      },
      
      rates: [
        {
          minBottles: 1,
          maxBottles: 3,
          price: 25.00,
          description: "1-3 bouteilles"
        },
        {
          minBottles: 4,
          maxBottles: 6,
          price: 28.00,
          description: "4-6 bouteilles"
        },
        {
          minBottles: 7,
          maxBottles: 9,
          price: 30.00,
          description: "7-9 bouteilles"
        },
        {
          minBottles: 10,
          maxBottles: Infinity,
          price: 0,           // GRATUIT
          description: "10+ bouteilles"
        }
      ]
    }
  },
  
  // =========================================================================
  // ZONE PAR DÉFAUT (pour les clients sans adresse)
  // =========================================================================
  
  defaultZone: "NETHERLANDS",
  
  // =========================================================================
  // SEUIL LIVRAISON GRATUITE PREMIÈRE COMMANDE
  // =========================================================================
  
  firstOrderFreeShippingThreshold: 3  // Nombre minimum de bouteilles
  
};
